module.exports = __webpack_public_path__ + "static/media/300_WAX.d0e27c06.webp";